import { useState, useMemo } from 'react';
import { endOfYear } from 'date-fns';
import { useAppContext } from 'src/app/state';
import { ActionType } from 'src/app/state/action-type.enum';
import {
  getCurrentTime,
  getDateWithCustomTime,
} from 'src/app/utils/date-time.utils';
import Button from '../button/Button';
import { TimeOptions } from 'src/types/date-time.types';
import Calendar from '../calendar/Calendar';
import TimeSelector from '../time-selector/TimeSelector';

type DateTimePopupContentProps = {
  showTimePicker: boolean;
  selectedDate?: Date;
  minDate?: Date;
  maxDate?: Date;
  datesDisabled: Date[];
  vyduraEveryDayDates?: Date[];
  vyduraPerAttacksDates?: Date[];
  migraineDates?: Date[];
  handleSelectDateTime: (date: Date) => void;
};

const DateTimePopupContent = ({
  showTimePicker,
  selectedDate,
  minDate,
  maxDate = endOfYear(new Date()),
  datesDisabled,
  vyduraEveryDayDates = [],
  vyduraPerAttacksDates = [],
  migraineDates = [],
  handleSelectDateTime,
}: DateTimePopupContentProps) => {
  const { dispatch } = useAppContext();
  const [selectedDateTime, setSelectedDateTime] = useState<Date | undefined>(
    selectedDate
  );
  const { hours, minutes, period } = useMemo(
    () => getCurrentTime(selectedDateTime),
    [selectedDateTime]
  );
  const handleSelectDate = (date: Date) => {
    const result = getDateWithCustomTime(
      date,
      getCurrentTime(selectedDateTime)
    );
    setSelectedDateTime(result);
  };
  const handleSelectTime = (time: TimeOptions) => {
    const result = getDateWithCustomTime(selectedDateTime ?? new Date(), time);
    setSelectedDateTime(result);
  };
  const handleCalendarClose = () => {
    handleSelectDateTime(selectedDateTime as Date);
    dispatch({ type: ActionType.POP_UP_CLOSE, payload: {} });
  };
  return (
    <>
      {showTimePicker && (
        <TimeSelector
          hours={hours}
          minutes={minutes}
          period={period}
          onTimeChange={handleSelectTime}
        />
      )}
      <Calendar
        selectedDate={selectedDateTime}
        className={`pb-2 relative ${showTimePicker ? 'mt-[8px]' : ''}`}
        onDateSelect={handleSelectDate}
        minDate={minDate}
        maxDate={maxDate}
        datesDisabled={datesDisabled}
        vyduraEveryDayDates={vyduraEveryDayDates}
        vyduraPerAttacksDates={vyduraPerAttacksDates}
        migraineDates={migraineDates}
      />
      <Button
        type='primary'
        width='full-width'
        style={{ marginTop: '32px', width: '100%', marginLeft: 0 }}
        onClick={handleCalendarClose}
        isReadOnly={selectedDateTime === undefined}
      >
        Confirm
      </Button>
    </>
  );
};

export default DateTimePopupContent;
